export default [
  {
    path: "/report/paid-Transaction",
    name: "PaidTransaction-View",
    component: () => import("@/views/reports/financial-report/index.vue"),
    meta: {
      resource: "Report",
      action: "PaidTransaction",
    },
  },
  {
    path: "/report/exceptionReport",
    name: "ExceptionReport-View",
    component: () =>
      import("@/views/reports/exception-report/exceptionTransaction.vue"),
    meta: {
      resource: "Report",
      action: "ExceptionReport",
    },
  },
  {
    path: "/report/manualtransaction",
    name: "ManualTransaction-View",
    component: () =>
      import("@/views/reports/exception-report/manualTransaction.vue"),
    meta: {
      resource: "Report",
      action: "ManualTransaction",
    },
  },
  {
    path: "/report/merchantresponse",
    name: "MerchantResponseGroup-View",
    component: () =>
      import("@/views/reports/exception-report/merchantErrorResponse.vue"),
    meta: {
      resource: "Report",
      action: "MerchantResponseGroup",
    },
  },
  {
    path: "/report/merchantresponse/:responseCode/:fromDate/:toDate/:merchantIds",
    name: "merchantResponseGroupDetail-view",
    component: () =>
      import(
        "@/views/reports/exception-report/merchantErrorResponseDetail.vue"
      ),
    meta: {
      resource: "Report",
      action: "MerchantResponseGroup",
    },
  },
  {
    path: "/report/market-share",
    name: "MarketShareReport-View",
    component: () => import("@/views/reports/market-share-report/index.vue"),
    meta: {
      resource: "Report",
      action: "MarketShareReport",
    },
  },
  {
    path: "/report/paymentSuccessRate",
    name: "PaymentSuccessRate-View",
    component: () =>
      import("@/views/reports/TransactionSuccessRate/payment.vue"),
    meta: {
      resource: "Report",
      action: "PaymentSuccessRate",
    },
  },
  {
    path: "/report/refundSuccessRate",
    name: "RefundSuccessRate-View",
    component: () =>
      import("@/views/reports/TransactionSuccessRate/refund.vue"),
    meta: {
      resource: "Report",
      action: "RefundSuccessRate",
    },
  },
  {
    path: "/report/transaction-trend",
    name: "TransactionalReport-View",
    component: () => import("@/views/reports/transaction-trend.vue"),
    meta: {
      resource: "Report",
      action: "TransactionalReport",
    },
  },
  {
    path: "/report/merchants-report",
    name: "MerchantsReport-View",
    component: () => import("@/views/reports/merchants-report.vue"),
    meta: {
      resource: "Report",
      action: "MerchantsReport",
    },
  },
  {
    path: "/report/payment-attempt",
    name: "PartnerAttemptPayment-View",
    component: () => import("@/views/reports/partner-attempt/payment.vue"),
    meta: {
      resource: "Report",
      action: "PartnerAttempt",
    },
  },
  {
    path: "/report/refund-attempt",
    name: "PartnerAttemptRefund-View",
    component: () => import("@/views/reports/partner-attempt/refund.vue"),
    meta: {
      resource: "Report",
      action: "PartnerAttempt",
    },
  },
  {
    path: "/report/payment-overall-transaction",
    name: "PaymentOverallTransaction-Report",
    component: () => import("@/views/reports/overall-trasaction/payment.vue"),
    meta: {
      resource: "Report",
      action: "PaymentOverallTransaction",
    },
  },
  {
    path: "/report/netsummeryreport",
    name: "NetSummeryReport-View",
    component: () => import("@/views/reports/netsummeryreport.vue"),
    meta: {
      resource: "Report",
      action: "NetSummeryReport",
    },
  },
  {
    path: "/report/performancereport",
    name: "PerformanceReport-View",
    component: () => import("@/views/reports/PerformanceReport/index.vue"),
    meta: {
      resource: "Report",
      action: "PerformanceReport",
    },
  },
  {
    path: "/report/refund-overall-transaction",
    name: "RefundOverallTransaction-Report",
    component: () => import("@/views/reports/overall-trasaction/refund.vue"),
    meta: {
      resource: "Report",
      action: "RefundOverallTransaction",
    },
  },
  {
    path: "/report/duplicate-transaction",
    name: "DuplicateTransaction-View",
    component: () => import("@/views/reports/duplicate-transaction/index.vue"),
    meta: {
      resource: "Report",
      action: "DuplicateTransaction",
    },
  },
  {
    path: "/userguide",
    name: "Order-View",
    component: () => import("@/views/UserGuide/index.vue"),
    meta: {
      resource: "UserGuide",
      action: "View",
    },
  },
];
